import { TalentPool } from '@recruitee/http/types';
import { createEntityCollectionStore, memoizeSelector } from '@recruitee/ngrx';

import { TalentPoolsScope } from './talent-pool.types';

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<TalentPool>()(
  'TalentPools',
  {
    customActions: adapter => ({
      fetchCollection: (state, payload: { scope: TalentPoolsScope }) =>
        adapter.markAsPending(state),
    }),
  },
);

const TalentPoolsNewSelectors = {
  ...selectors,
  entities: memoizeSelector((archived: boolean = false) =>
    selectors.entities({ scope: archived ? TalentPoolsScope.Archived : TalentPoolsScope.Default }),
  ),
};

export {
  TalentPoolsNewSelectors,
  actions as TalentPoolsNewActions,
  reducer as TalentPoolsReducer,
  namespace as TalentPoolsNamespace,
};
